export const isImage = (imagePath: string) => {
  const extension = getImageExtensionFromURL(imagePath);
  if (!extension || extension.length === 0) return false;
  return ["png", "jpg", "jpeg"].includes(extension);
};

export const getFileType = (url: string) => {
  const cleanUrl = url.split("?")[0]; // remove query params
  const extension = cleanUrl.split(".").pop()?.toLowerCase();

  if (!extension) return "unknown";

  if (["mp4", "webm", "ogg"].includes(extension)) return "video";
  if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension)) return "image";

  return "unknown";
};

export const getImageExtensionFromURL = (imagePath: string) => {
  return imagePath?.split(/[#?]/)?.[0]?.split(".")?.pop()?.trim();
};

export const DOC_STATUS = [
  "Document marked as Sampled Negative",
  "Document marked as Sampled Decline"
];

export const [
  DOC_STATUS_SCREENED,
  DOC_STATUS_UNDER_REVIEW,
  DOC_STATUS_SAMPLED,
  DOC_STATUS_NOT_VERIFIED,
  DOC_SAMPLED_POSITIVE,
  DOC_SAMPLED_REFER,
  DOC_SAMPLED_NEGATIVE,
  DOC_SAMPLED_DECLINE,
  DOC_STATUS_HOLD
] = [3, 0, 2, 1, 4, 5, 6, 7, 8];
